
import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '@/components/ui/button';

const BlogPostNotFound: React.FC = () => {
  return (
    <div className="text-center py-12">
      <h2 className="text-2xl font-semibold mb-4">Blog post not found</h2>
      <p className="text-gray-600 mb-6">The blog post you're looking for doesn't exist or has been removed.</p>
      <Link to="/blog">
        <Button>Go back to all posts</Button>
      </Link>
    </div>
  );
};

export default BlogPostNotFound;
